{
  "source": "https://laapparel.info/wp-json/wp/v2/wholesale_product?slug=2017",
  "headers": [
    "",
    "Body Length",
    "Chest Width",
    "Sleeve Length"
  ],
  "rows": [
    [
      "S",
      "26 3/4",
      "18",
      "7 3/4"
    ],
    [
      "M",
      "27 7/8",
      "20",
      "8 1/8"
    ],
    [
      "L",
      "29",
      "22",
      "8 3/8"
    ],
    [
      "XL",
      "30",
      "24",
      "8 5/8"
    ],
    [
      "2XL",
      "31",
      "26",
      "8 7/8"
    ],
    [
      "3XL",
      "32",
      "28",
      "9 1/4"
    ]
  ],
  "image": "https://laapparel.info/wp-content/uploads/2025/04/SIZE_073125_tshirts-1.png"
}
